module.exports = __webpack_public_path__ + "img/DasKleid.9ddc84ab.jpg";